// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./vue2-daterange-picker.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("2169aa57", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue2-daterange-picker/dist/vue2-daterange-picker.css
// module id = 73
// module chunks = 0